import { createContext, useContext } from "react";
import { defaultConfig } from "../constants";

export const ConfigContext = createContext(defaultConfig);

export function useConfigContext() {
  return useContext(ConfigContext);
}
